import { Component, ElementRef, OnChanges, OnInit, TemplateRef, ViewChild, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

export interface TrainingGroupUserInterface {
  groupId: number;
  userId: number;
  userName: string;
  userFullName: string;
  assignedOn: Date;
  assignedBy: number;
  assignedByUser: string;
  deleteReason: string;
}

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-tms-group-users',
  templateUrl: './tms-group-users.component.html',
  styleUrls: ['./tms-group-users.component.scss']
})
export class TmsGroupUsersComponent implements OnInit, OnChanges {

  @Input() trainingGroupdata: any = {};
  searchText: any;
  searchValue: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  trainingGroupUserDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  warningMsg: any;
  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;
  infoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  constructor(public dialog: MatDialog, readonly appService: AppService, public router: Router, readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, readonly elem: ElementRef) { }

  ngOnInit() {
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();

  }

  ngOnChanges() {
    this.getcallMethod();
  }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.trainingGroupUserDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.trainingGroupUserDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.trainingGroupUserDataForGrid = [];

    const data = {

      gridName: "TRAINING_GROUP_USERS"
    };

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "GROUP_USERS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          groupId: this.trainingGroupdata.groupId.toString(),
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? ""
        };

        this.reportObj = { ...data1, ...data };

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.trainingGroupUserDataForGrid = response1;
            this.visibleAuditTrail = false;

            data1.columnsListarray = data1.columnsList.split(",");
            const rawLabels = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            const rawSizes = data1.fieldSizeList.split(",");
            const validColumns = [];
            const validLabels = [];
            const validSizes = [];

            for (let i = 0; i < data1.columnsListarray.length; i++) {
              const colName = data1.columnsListarray[i];
              if (!data1.invisibleColumnarray.includes(colName)) {
                validColumns.push(colName);
                validLabels.push({
                  fieldColumnarray: rawLabels[i],
                  width: (rawSizes[i] ?? '0') + 'px'
                });
                validSizes.push((rawSizes[i] ?? '0') + 'px');
              }
            }

            this.columnLists.columnsListarray = validColumns;
            this.columnLists.fieldColumnarray = validLabels;
            this.columnLists.fieldSizeListArray = validSizes;
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;

            const tableData = {
              tablename: data1.tableOrViewName
            };

            this.columnLists.columnsListarray1 = [];

            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;

                for (const colName of this.columnLists.columnsListarray) {
                  const currentType = this.getFieldType(colName);

                  this.columnLists.columnsListarray1.push({
                    columnsListarray: colName,
                    dataType: currentType,
                    width: this.columnLists.fieldSizeListArray
                  });
                }

                this.convertCheckboxValues();

                // Pagination Setup
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              },
              error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });

            this.message.gridList = this.trainingGroupUserDataForGrid;
            this.collectionSize = this.trainingGroupUserDataForGrid.length;
            this.totalPages = Math.ceil(this.trainingGroupUserDataForGrid.length / this.itemsPerPage);
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  private getFieldType(columnName: string): string {
    const matchedType = this.dataTypeList.find((t: any) => t.columnName === columnName);
    return matchedType ? matchedType.fieldType : 'textbox';
  }

  private convertCheckboxValues() {
    for (const row of this.trainingGroupUserDataForGrid) {
      for (const typeItem of this.dataTypeList) {
        if (typeItem.fieldType === 'CHECKBOX') {
          row[typeItem.columnName] = row[typeItem.columnName] === "Y";
        }
      }
    }
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.trainingGroupUserDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.trainingGroupUserDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(event: any) {
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;

    for (const row of this.trainingGroupUserDataForGrid) {
      row.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.trainingGroupUserDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.USER_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.trainingGroupUserDataForGrid.some((list: any) => list.childCheckBoxs);
  }

  userName: any;
  userNameRequiredMsg: any;
  fieldValidation() {
    this.userName = document.getElementById('userName') as HTMLInputElement;
    this.userNameRequiredMsg = document.getElementById('userName-required-msg') as HTMLInputElement;

    if (this.trainingGroupUserFieldData.userId == "") {
      this.userName.style.border = '1px solid red';
      this.userNameRequiredMsg.style.display = 'block';
    } else {
      this.userName.style.border = 'none';
      this.userNameRequiredMsg.style.display = 'none';
    }
  }


  trainingGroupUserFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('searchUser', { static: true }) searchUser: TemplateRef<any>;
  @ViewChild('trainingGroupUserActiveInactivePopup', { static: true }) trainingGroupUserActiveInactivePopup: TemplateRef<any>;

  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleTrainingGroupUserActiveInactivePopup: MatDialogRef<TemplateRef<any>>;

  searchUserConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  addAndEditPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: false,
    position: { top: '10px' },
  };

  trainingGroupUserActiveInactivePopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.trainingGroupUserFieldData = {};
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Training Group User";
    this.trainingGroupUserFieldData.userId = '';
    this.getSelectedUserId = [];
    this.getSelectedUserName = [];
    this.trainingGroupUserFieldData.groupId = this.trainingGroupdata['groupId'];
    this.searchUserChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.departmentCodeValue = null;
    this.designationCodeValue = null;
    this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchUserConfig);
  }

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  backToPreviousPage() {
    this.router.navigate(['dashboard/trainingGroups']);
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;

  addAndEditFunction(trainingGroupUserFieldData: any) {
    this.isProcessing = true;
    if (this.getSelectedUserId.length == 0) {
      this.warningMsg = "Please select users!";
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
      this.isProcessing = false;
    } else {
      if (this.operationFlag == 'ADD') {
        trainingGroupUserFieldData.userIdList = this.getSelectedUserId;
        trainingGroupUserFieldData.groupId = this.trainingGroupdata.groupId;
        this.appService.createTmsGroupUser(trainingGroupUserFieldData).subscribe((Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          this.isProcessing = false;
          if (this.displayResultType == 'S') {
            this.visibleSearchUserPopup.close();
            this.getcallMethod();

          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel == null ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });



      }
    }
  }

  okInfo() {
    this.visibleInfoPopup.close();
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteTrainingGroupUserUserId: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Training Group User";
    this.deleteTrainingGroupUserUserId = deleteRowData.USER_ID;
    if (this.trainingGroupUserFieldData.deleteReason != undefined) {
      this.trainingGroupUserFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteTrainingGroupUserData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      this.deleteTrainingGroupUserData = {
        groupId: this.trainingGroupdata.groupId,
        userId: this.deleteTrainingGroupUserUserId,
        deleteReason: this.trainingGroupUserFieldData.deleteReason,
      };
      this.appService.deleteTmsGroupUser(this.deleteTrainingGroupUserData).subscribe((Response: any) => {
        this.displayMessage = Response.result;
        this.displayResultType = Response.resultType;
        if (this.displayResultType == 'S') {
          this.visibleDeletePopup.close();
          this.getcallMethod();
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });

      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  searchUserParentCheckBox: boolean = false;
  searchUserChildCheckBoxs: boolean = false;
  searchUserChildCheckBoxsMenu: boolean = false;

  searchUserDataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      for (let k = 0; k < this.getOneQmsUsersVwDetailsTableData.length; k++) {
        this.getOneQmsUsersVwDetailsTableData[k].searchUserChildCheckBoxs = true;
        this.getSelectedUserId.push(this.getOneQmsUsersVwDetailsTableData[k].userId);
        this.getSelectedUserName.push(this.getOneQmsUsersVwDetailsTableData[k].userName);
      }

    } else {
      for (let k = 0; k < this.getOneQmsUsersVwDetailsTableData.length; k++) {
        this.getOneQmsUsersVwDetailsTableData[k].searchUserChildCheckBoxs = false;
      }
      this.getSelectedUserId = [];
      this.getSelectedUserName = [];
    }
  }

  getSelectedUserId: any = [];
  getSelectedUserName: any = [];
  searchUserChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfUsersVwDetails.searchUserChildCheckBoxs = true;
      this.getSelectedUserId.push(listOfUsersVwDetails.userId);
      this.getSelectedUserName.push(listOfUsersVwDetails.userName);
    } else {
      listOfUsersVwDetails.searchUserChildCheckBoxs = false;
      this.getSelectedUserId.splice(this.getSelectedUserId.indexOf(listOfUsersVwDetails.userId), 1);
      this.getSelectedUserName.splice(this.getSelectedUserName.indexOf(listOfUsersVwDetails.userName), 1);
    }

  }

  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = [];
  searchByDepartmentCode: any = [];
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];

  searchUserFunction() {
    this.searchUserChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.departmentCodeValue = null;
    this.designationCodeValue = null;
    this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchUserConfig);
  }

  addUserNameFunction() {
    this.addAndEditFunction(this.trainingGroupUserFieldData);
  }

  cancelSearchUserFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchUserPopup.close();
  }

  searchUserGridDataFunction() {
    this.isProcessing = true;
    if (this.searchByUserName != null) {
      let searchByUserName = this.searchByUserName.toUpperCase();
    } else {
      this.searchByUserName = '';
    }
    this.searchOneQmsUserVwDetails = {
      userName: this.searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue ? this.designationCodeValue : null,
      departmentCode: this.departmentCodeValue ? this.departmentCodeValue : null,
      groupId: this.trainingGroupdata.groupId
    };
    this.appService.getTrainingsUsersList(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response.sort((m: { userName: string }, n: { userName: string }) => m?.userName?.trim()?.localeCompare(n?.userName?.trim()));
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchUserGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.departmentCodeValue = null;
    this.designationCodeValue = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  selectBoxeForDesignationCode() {
    for (let i = 0; i < this.dropDownForDesignationCode.length; i++) {
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: this.dropDownForDesignationCode[i].codelistCode,
        displayExp: this.dropDownForDesignationCode[i].codelistName
      });
    }
  }

  selectBoxeForDepartmentCode() {
    for (let i = 0; i < this.dropDownForDepartmentCode.length; i++) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: this.dropDownForDepartmentCode[i].codelistCode,
        displayExp: this.dropDownForDepartmentCode[i].codelistName
      });
    }
  }

  selectedDesignationValue: any;
  selectedDepartmentValue: any;

  designationsearchTxt: any;
  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.designationCodeValue = item.valueExp;
      }
    }
  }
  departmentsearchTxt: any;
  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.departmentCodeValue = item.valueExp;
      }
    }
  }

  onDesignationCodeSelectOld(item: any) {
    this.selectedDesignationValue = item.valueExp;
  }
  onDesignationCodeRemoved(item: any) { }

  onDepartmentCodeSelectOld(item: any) {
    this.selectedDepartmentValue = item.valueExp;
  }
  onDepartmentCodeRemoved(item: any) { }

  activeInactiveLabel: String;
  activeInactiveButtonLabel: String;
  errorMsgContent: String;
  activeInactiveGroupId: Number;
  activeInactiveuserId: Number;
  groupUserActionFlag: Boolean;
  openActiveAndInActivePopup(tmsGroupUsersActiveInactiveRowData: any) {
    if (tmsGroupUsersActiveInactiveRowData.IS_ACTIVE) {
      this.popupTitle = "User Inactivation";
      this.activeInactiveLabel = "Reason for Inactivation";
      this.activeInactiveButtonLabel = "Inactivate";
      this.errorMsgContent = "Inactivation";
      this.groupUserActionFlag = false;
    } else {
      this.popupTitle = "User Activation";
      this.activeInactiveLabel = "Reason for Activation";
      this.activeInactiveButtonLabel = "Activate";
      this.errorMsgContent = "Activation";
      this.groupUserActionFlag = true;
    }
    this.activeInactiveGroupId = tmsGroupUsersActiveInactiveRowData.GROUP_ID;
    this.activeInactiveuserId = tmsGroupUsersActiveInactiveRowData.USER_ID;
    this.trainingGroupUserFieldData.groupUserActiveInactiveReason = "";
    this.visibleTrainingGroupUserActiveInactivePopup = this.dialog.open(this.trainingGroupUserActiveInactivePopup, this.trainingGroupUserActiveInactivePopupConfig);
  }

  cancelTmsGroupUsersActiveInActiveFunction() {
    this.visibleTrainingGroupUserActiveInactivePopup.close();
  }

  groupUserActiveInactiveReasonValue: any;
  groupUserActiveInactiveReasonRequiredMsg: any;
  tmsGroupActiveInactiveValidation() {
    this.groupUserActiveInactiveReasonValue = document.getElementById('groupUserActiveInactiveReason') as HTMLInputElement;
    this.groupUserActiveInactiveReasonRequiredMsg = document.getElementById('groupUserActiveInactiveReason-required-msg') as HTMLInputElement;
    if (this.trainingGroupUserFieldData.groupUserActiveInactiveReason == "") {
      this.groupUserActiveInactiveReasonValue.style.border = '1px solid red';
      this.groupUserActiveInactiveReasonRequiredMsg.style.display = 'block';
    } else {
      this.groupUserActiveInactiveReasonValue.style.border = 'none';
      this.groupUserActiveInactiveReasonRequiredMsg.style.display = 'none';
    }
  }

  tmsGroupUsersActiveInActiveFunction(trainingGroupUserFieldData: any) {
    this.isProcessing = true;
    if (this.trainingGroupUserFieldData.groupUserActiveInactiveReason == "") {
      this.tmsGroupActiveInactiveValidation();
      this.isProcessing = false;
    } else {
      const isActiveValue = this.groupUserActionFlag ? 'ACTIVATE' : 'INACTIVATE';
      let tmsGroupUserActiveInactiveData = {
        groupId: this.activeInactiveGroupId,
        userId: this.activeInactiveuserId,
        isActive: isActiveValue,
        inActiveReason: this.trainingGroupUserFieldData.groupUserActiveInactiveReason,
      };
      this.appService.tmsGroupUserActiveInactive(tmsGroupUserActiveInactiveData).subscribe((Response: any) => {
        this.displayMessage = Response.result;
        this.displayResultType = Response.resultType;
        if (this.displayResultType == 'S') {
          this.visibleTrainingGroupUserActiveInactivePopup.close();
          this.getcallMethod();
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.trainingGroupUserDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column as string;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, trainingGroup: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : trainingGroup.USER_ID;
    this.auditTrail.groupId = this.trainingGroupdata.groupId;
    this.auditTrail.gridName = 'TRAINING_GROUP_USERS';
    this.auditTrail.report_And_Popup_Name = 'Trainings Group Users Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(trainingGroup);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Trainings Group Users Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };
}
